import { render, staticRenderFns } from "./HideModalButton.vue?vue&type=template&id=58b1b653&scoped=true&"
import script from "./HideModalButton.vue?vue&type=script&lang=js&"
export * from "./HideModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1b653",
  null
  
)

export default component.exports